import { combineReducers } from 'redux';

import { OPEN_MODAL, CLOSE_MODAL } from './actions';
import { OpenModalState, OpenModalAction } from './types';

const openModalReducer = (state: OpenModalState = [], action: OpenModalAction) => {
  switch (action.type) {
    case OPEN_MODAL:
      const { modalName } = action.payload;
      const isAlreadyOpen = state.find((openModalName) => openModalName === modalName);

      if (isAlreadyOpen) {
        return state;
      }

      return state.concat(modalName);
    case CLOSE_MODAL:
      return state.filter((openModalName) => openModalName !== action.payload.modalName);
    default:
      return state;
  }
};

const modalReducer = combineReducers({
  openModals: openModalReducer,
});

export default modalReducer;
